import { useState, useEffect } from "react";
import side_img from "../../assets/pic/login_signup_img.svg";
import { Link } from "react-router-dom";
import { BsEyeSlash, BsEye } from "react-icons/bs";
import { toast } from "react-toastify";
import Spinner from "../../components/Spinner";
import SignupOTP from "../../components/SignupOTP";
import { LayoutForLandingPage } from "./Home";

const Signup = () => {
  const [fullName, setfullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassowrd] = useState("");
  const [verifyToken, setVerifyToken] = useState("");
  const [address, setAddress] = useState("");
  const [gender, setGender] = useState("");
  const [OTPModal, setOTPModal] = useState(false);
  const [loader, setLoader] = useState(false);

  const handleOpenOTPModal = () => {
    setOTPModal(true);
  };

  const handleCloseOTPModal = () => {
    setOTPModal(false);
  };

  useEffect(() => {
    // Prevent scrolling of body content when the modal is open
    if (OTPModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [OTPModal]);

  const [showPassword, setShowPassword] = useState(false); // state to control password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false); // state to control confirm password visibility
  const [showPasswordNotMatch, setShowPasswordNotMatch] = useState(false);
  const [showEmailAlreadyExists, setShowEmailAlreadyExists] = useState(false);
  const [showFillAllFields, setShowFillAllFields] = useState(false);
  const [showValidPasswordError, setShowValidPasswordError] = useState(false);

  const togglePasswordVisibilty = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibilty = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    setShowConfirmPassword(false);
    setShowPasswordNotMatch(false);
    setShowEmailAlreadyExists(false);
    setShowValidPasswordError(false);
    setShowFillAllFields(false);
    if (
      fullName === "" ||
      email === "" ||
      password === "" ||
      confirmPassword === ""
      // dob === "" ||
      // gender === "" ||
      // address === ""
    ) {
      setShowFillAllFields(true);
      setLoader(false);
      return;
    }
    if (password !== confirmPassword) {
      setShowPasswordNotMatch(true);
      setLoader(false);
      return;
    } else if (password?.length < 5) {
      setShowValidPasswordError(true);
      setLoader(false);
      return;
    }
    const signup = async () => {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/api/customer/user-signup`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            fullName,
            // dob,
            // address,
            email,
            password,
            confirmPassword,
            // gender,
          }),
        }
      );
      const data = await res.json();
      setLoader(false);
      if (data.code === 400 && data.message === "Email already exists!") {
        setShowEmailAlreadyExists(true);
        return;
      } else if (
        data.code === 200
        // &&
        // data.message === "Signed up successfully"
      ) {
        toast.info(data.message || "OTP has been sent to your email ID", {
          autoClose: 60000,
          hideProgressBar: true,
        });
        console.log("hello");
        setVerifyToken(data.data.token);
        console.log({ data: data.data });
        handleOpenOTPModal();
      }
    };
    signup();
  };

  return (
    // <section className="flex xl:flex-row flex-col h-screen">
    //   <img
    //     src={side_img}
    //     alt="login_signup_side_bg"
    //     className="lg:h-screen xl:flex hidden object-contain"
    //   />
    // <section className="flex xl:flex-row flex-col h-screen overflow-hidden">
    //   <img
    //     src={side_img}
    //     alt="login_signup_side_bg"
    //     className="fixed left-0 top-0 w-1/2 h-full bg-no-repeat bg-cover"
    //   />
    <LayoutForLandingPage>
      <section className="flex justify-center items-center h-full mb-10  mt-20">
        {/* Card Container */}
        <div className="flex w-full bg-white rounded-lg shadow-lg overflow-hidden">
          {/* Image Section */}
          <div className="w-full xl:w-1/2 hidden xl:block">
            <img
              src={side_img}
              alt="login_signup_side_bg"
              className="w-full h-full object-cover"
              style={{ height: "100%" }} // Ensure full height
            />
          </div>

          {/* <div className="xl:w-1/2 w-full h-full overflow-y-auto">
        <div className="flex items-center justify-center h-full overflow-y-auto xl:flex hidden w-1/2">
          The form will be here, and will be scrollable
          <form
            className="md:text-xl text-lg md:px-10 p-5 my-auto"
            // className="md:text-xl text-lg md:px-10 p-5 my-auto w-full max-w-lg"

            onSubmit={handleSubmit}
          >
            Your form inputs
          </form>
        </div> */}

          {OTPModal && (
            <SignupOTP
              handleCloseOTPModal={handleCloseOTPModal}
              token={verifyToken}
            />
          )}
          <form
            className="w-full xl:w-1/2 px-8 py-2 space-y-1 flex flex-col justify-center"
            onSubmit={handleSubmit}
          >
            <h1 className="text-4xl font-bold text-slate-500">
              Create Account
            </h1>
            <div className="flex flex-col w-full">
              <label className="mt-6 text-lg font-semibold">Full Name</label>
              <input
                type="text"
                name="fullName"
                required
                value={fullName}
                onChange={(e) => setfullName(e.target.value)}
                placeholder="Please enter your full name"
                className="py-2 bg-none border-b-[3px] border-gray-400 focus:outline-none placeholder:text-gray-400 w-full"
              />
            </div>
            <div className="flex flex-col w-full">
              <label className="mt-3 text-lg font-semibold">Email ID</label>
              <input
                type="email"
                name="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Please enter your email ID"
                className={` py-2 bg-none border-b-[3px] focus:outline-none placeholder:text-gray-400 w-full ${
                  showEmailAlreadyExists ? "border-primary" : "border-gray-400"
                }`}
              />
              {showEmailAlreadyExists && (
                <p className="text-sm text-[#C10020]">
                  This email ID is already registered, Go to Sign in.
                </p>
              )}
            </div>
            <div className="flex flex-col w-full relative">
              <label className="mt-3 text-lg font-semibold">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Please enter your Password"
                className={` py-2 bg-none border-b-[3px] focus:outline-none placeholder:text-gray-400 w-full ${
                  showPasswordNotMatch ? "border-primary" : "border-gray-400"
                }`}
              />
              <div
                className={`absolute inset-y-0 ${
                  showConfirmPassword ? "top-5" : "top-10"
                } right-3 flex items-center cursor-pointer`}
                onClick={togglePasswordVisibilty}
              >
                {showPassword ? (
                  <BsEye size={30} className="text-gray-500" />
                ) : (
                  <BsEyeSlash size={30} className="text-gray-500" />
                )}
              </div>
            </div>
            <div className="flex flex-col w-full relative">
              <label className="mt-3 text-lg font-semibold">
                Confirm Password
              </label>
              <input
                type={showConfirmPassword ? "text" : "password"}
                value={confirmPassword}
                onChange={(e) => setConfirmPassowrd(e.target.value)}
                placeholder="Please enter your Password"
                required
                className={` py-2 bg-none border-b-[3px] focus:outline-none ${
                  showPasswordNotMatch ? "border-primary" : "border-gray-400"
                } placeholder:text-gray-400 w-full`}
              />
              {showPasswordNotMatch && (
                <p className="text-sm text-[#C10020]">
                  Password and confirm password do not match
                </p>
              )}{" "}
              {showValidPasswordError && (
                <p className="text-sm text-[#C10020]">
                  Password must be 5 character long.
                </p>
              )}
              <div
                className={`absolute inset-y-0 ${
                  showPasswordNotMatch ? "top-5" : "top-10"
                } right-3 flex items-center cursor-pointer`}
                onClick={toggleConfirmPasswordVisibilty}
              >
                {showConfirmPassword ? (
                  <BsEye size={30} className="text-gray-500" />
                ) : (
                  <BsEyeSlash size={30} className="text-gray-500" />
                )}
              </div>
            </div>
            {/* <div className="flex flex-col w-full">
              <label className="mt-3 text-lg font-semibold">Birthday</label>
              <input
                type="date"
                name="dob"
                value={dob}
                required
                onChange={(e) => setdob(e.target.value)}
                className="py-2 bg-none border-b-[3px] focus:outline-none border-gray-400 placeholder:text-gray-400 w-full"
              />
            </div>
            <div className="flex flex-col w-full">
              <label className="mt-3 text-lg font-semibold">Address</label>
              <input
                type="text"
                name="address"
                value={address}
                placeholder="Please enter your address"
                required
                onChange={(e) => setAddress(e.target.value)}
                className="py-2 bg-none border-b-[3px] focus:outline-none border-gray-400 placeholder:text-gray-400 w-full"
              />
            </div>
            <div className="flex flex-col w-full">
              <label className="mt-3 text-lg font-semibold">Gender</label>
              <div className="flex items-center gap-x-4 w-full mb-6">
                <div className="flex items-center gap-x-2">
                  <input
                    type="radio"
                    id="male"
                    name="gender"
                    checked={gender === "Male"}
                    value="Male"
                    onChange={() => setGender("Male")}
                  />
                  <label htmlFor="male">Male</label>
                </div>
                <div className="flex items-center gap-x-2">
                  <input
                    type="radio"
                    id="female"
                    name="gender"
                    checked={gender === "Female"}
                    value="Female"
                    onChange={() => setGender("Female")}
                  />
                  <label htmlFor="female">Female</label>
                </div>
              </div>
            </div> */}

            <div className="flex items-center gap-4">
              <input
                type="checkbox"
                name="TOS"
                required
                id="TOS"
                className="w-4 h-4 bg-[#E5E8EC] mb-2"
              />
              <label className="text-sm mb-2">
                I agree to the{" "}
                <span className="text-blue-700 hover:underline cursor-pointer">
                  terms and condition
                </span>{" "}
                &{" "}
                <span className="text-blue-700 hover:underline cursor-pointer">
                  privacy policy
                </span>
              </label>
            </div>
            {loader ? (
              <Spinner props=" " size={"80"} />
            ) : (
              // <button className="bg-[#F59930] text-white font-semibold text-xl rounded-lg px-10 py-2 md:flex hidden hover:brightness-90 duration-200 ease-linear">
              <button className="bg-[#F66] text-white font-semibold text-xl rounded-lg px-10 py-2  hover:bg-primary-dark duration-200 ease-linear">
                Sign up
              </button>
            )}
            {showFillAllFields && (
              <p className="text-sm text-[#C10020]">
                Please fill all the required fields
              </p>
            )}
            <p className="text-sm mt-4">
              Already have an account?{" "}
              <Link className="text-blue-700 hover:underline" to={"/login"}>
                Log in
              </Link>
            </p>
          </form>
        </div>
      </section>
    </LayoutForLandingPage>
  );
};

export default Signup;
